
import {Component, Vue} from 'vue-property-decorator';
import Client from '@/data/models/client';
import CreateUpdateClient from '@/views/admin/clients/CreateUpdateClient.vue';

/** Onglet « Clients » de l'administration : liste, création, modification, accès aux bâtiments. */
@Component({components: {CreateUpdateClient}})
export default class AdminClients extends Vue {
  headers = [
    {text: 'Nom', value: 'name'},
    {text: 'Email', value: 'email'},
    {text: '', value: 'action', align: 'right', sortable: false},
  ];

  client: Client = Client.map({});
  opened = false;
  loading = true;
  search = '';
  clients: Array<Client> = [];

  mounted(): void {
    this.getClients();
  }

  handleUpdate(data?: Client): void {
    this.opened = true;
    this.client = Object.assign(Client.map({}), data) ?? Client.map({});
  }

  handleBuildings(data: Client): void {
    this.$store.commit('setBreadCrumbName', `| ${data.nameSurname}`);
    this.$router.push({name: 'listBuildings', params: {uid: data.id}});
  }

  dialogClosed(): void {
    this.opened = false;
    this.getClients();
  }

  getClients(): void {
    this.loading = true;
    this.$dao.clients.getAll()
        .then((result) => this.clients = result.filter(it => it.status != 'deleted'))
        .finally(() => this.loading = false);
  }
}
